import script from "./OrderDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDetailPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__